"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CollegeSavingsPageTwo;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _CollapseInfo = _interopRequireDefault(require("../Wizard/CollapseInfo"));
var _DisclosureModal = _interopRequireDefault(require("../Wizard/DisclosureModal"));
var _utils = require("../../middleware/utils");
var _CollegeSavingsRefineModal = _interopRequireDefault(require("./CollegeSavingsRefineModal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function CollegeSavingsPageTwo(_ref) {
  var _apiData$data3, _apiData$data4, _apiData$data5;
  var {
    apiData,
    showDisclosureModal,
    disclosureHandleClose,
    fetchDataScienceResults,
    refinementHandleClose,
    showRefinement,
    snapshot
  } = _ref;
  var {
    values: {
      savings,
      numOfKids,
      rateReturn
    },
    values,
    setFieldValue
  } = (0, _formik.useFormikContext)();
  var closeAndResetRefinementModal = snapshot => {
    refinementHandleClose();
    // We might be able to use setValues instead of looping through.
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };

  // Total children college costs for UI grand total field
  var allChildTotal = 0;
  for (var i = 1; i <= numOfKids; i++) {
    var _apiData$data;
    if (!isNaN(apiData === null || apiData === void 0 || (_apiData$data = apiData.data) === null || _apiData$data === void 0 || (_apiData$data = _apiData$data["child".concat(i)]) === null || _apiData$data === void 0 || (_apiData$data = _apiData$data.totalCollegeCost) === null || _apiData$data === void 0 ? void 0 : _apiData$data[0])) {
      var _apiData$data2;
      allChildTotal += apiData === null || apiData === void 0 || (_apiData$data2 = apiData.data) === null || _apiData$data2 === void 0 || (_apiData$data2 = _apiData$data2["child".concat(i)]) === null || _apiData$data2 === void 0 || (_apiData$data2 = _apiData$data2.totalCollegeCost) === null || _apiData$data2 === void 0 ? void 0 : _apiData$data2[0];
    }
  }
  var titleText = "College Savings Goal";
  var contentArray1 = [{
    label: 'Current savings',
    value: (0, _utils.numberToCurrencyString)(savings),
    id: 'currentSavings'
  }, {
    label: 'Your additional contributions',
    value: (0, _utils.numberToCurrencyString)(apiData === null || apiData === void 0 || (_apiData$data3 = apiData.data) === null || _apiData$data3 === void 0 || (_apiData$data3 = _apiData$data3.Overall) === null || _apiData$data3 === void 0 || (_apiData$data3 = _apiData$data3.cumContribution) === null || _apiData$data3 === void 0 ? void 0 : _apiData$data3[0]),
    id: 'additionalContributions'
  }];

  // For this portion of the CollapseInfo, we need to iterate over part of the API response
  // In order to programatically generate the proper labels
  var monthlyContributions = apiData === null || apiData === void 0 || (_apiData$data4 = apiData.data) === null || _apiData$data4 === void 0 || (_apiData$data4 = _apiData$data4.Overall) === null || _apiData$data4 === void 0 ? void 0 : _apiData$data4.monthlyContribution;
  var periodCounter = 0;
  monthlyContributions === null || monthlyContributions === void 0 || monthlyContributions.forEach((period, index) => {
    if (periodCounter == 0) {
      contentArray1.push({
        label: "Monthly savings goal until ".concat(period.to[0]),
        value: (0, _utils.numberToCurrencyString)(period.monthlyContribution),
        id: "monthlySavingsGoal".concat(index)
      });
    } else {
      if (period.from[0] == period.to[0]) {
        contentArray1.push({
          label: "Monthly savings in ".concat(period.to[0]),
          value: (0, _utils.numberToCurrencyString)(period.monthlyContribution),
          id: "monthlySavingsGoal".concat(index)
        });
      } else {
        contentArray1.push({
          label: "Monthly savings from ".concat(period.from[0], " to ").concat(period.to[0]),
          value: (0, _utils.numberToCurrencyString)(period.monthlyContribution),
          id: "monthlySavingsGoal".concat(index)
        });
      }
    }
    periodCounter++;
  });
  contentArray1.push({
    label: 'Potential savings return ',
    value: (0, _utils.numberToCurrencyString)(apiData === null || apiData === void 0 || (_apiData$data5 = apiData.data) === null || _apiData$data5 === void 0 || (_apiData$data5 = _apiData$data5.Overall) === null || _apiData$data5 === void 0 || (_apiData$data5 = _apiData$data5.investmentGrowth) === null || _apiData$data5 === void 0 ? void 0 : _apiData$data5[0]),
    id: 'potentialSavingsReturn',
    popoverText: "Assumes a rate of return of ".concat(rateReturn, "% on savings. Click \"Edit Your Inputs & Our Assumptions\" to update this value."),
    popoverId: "potentialSavings"
  });
  var collapseArray = [];
  for (var _i = 1; _i <= numOfKids; _i++) {
    var _apiData$data6, _apiData$data7;
    var label = "Estimated tuition, fees, room, and board cost: <strong>".concat(childMap[_i], " Child</strong>");
    var contentArray = [{
      label: 'College type',
      value: (0, _utils.capitalizeFirstLetter)(values.children[_i - 1].collegeTerm),
      id: "child".concat(_i, "collegeType")
    }, {
      label: 'Starting year',
      value: apiData === null || apiData === void 0 || (_apiData$data6 = apiData.data) === null || _apiData$data6 === void 0 || (_apiData$data6 = _apiData$data6["child".concat(_i)]) === null || _apiData$data6 === void 0 || (_apiData$data6 = _apiData$data6.collegeStart) === null || _apiData$data6 === void 0 ? void 0 : _apiData$data6[0],
      id: "child".concat(_i, "startingYear")
    }];
    collapseArray.push(/*#__PURE__*/_react.default.createElement(_CollapseInfo.default, {
      key: _i,
      label: label,
      id: "child".concat(_i, "info"),
      total: (0, _utils.numberToCurrencyString)(apiData === null || apiData === void 0 || (_apiData$data7 = apiData.data) === null || _apiData$data7 === void 0 || (_apiData$data7 = _apiData$data7["child".concat(_i)]) === null || _apiData$data7 === void 0 || (_apiData$data7 = _apiData$data7.totalCollegeCost) === null || _apiData$data7 === void 0 ? void 0 : _apiData$data7[0]),
      contentArray: contentArray
    }));
  }
  var disclosureArray = ['This interactive calculator is a self-help tool and is not intended to provide financial advice or product recommendations. The results and explanations generated by this calculator are based upon, and will vary due to, your input and certain assumptions made by us. All projections are hypothetical in nature, do not reflect actual results, and are not guarantees of future results. MassMutual will assume no liability for the use of or reliance on this calculator. For a more accurate and detailed analysis specific to your circumstances, we encourage you to contact a qualified financial professional.', 'The information provided is not written or intended as specific tax or legal advice. MassMutual, its employees and representatives are not authorized to give tax or legal advice. Individuals are encouraged to seek advice from their own tax or legal counsel.', 'Insurance products issued by Massachusetts Mutual Life Insurance Company (MassMutual) and its subsidiaries, C.M. Life Insurance Company (C. M. Life) and MML Bay State Life Insurance Company (MML Bay State), Springfield, MA 01111-0001. C.M. Life and MML Bay State are non-admitted in New York.'];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h4", null, titleText), /*#__PURE__*/_react.default.createElement("h3", {
    className: "data-lg"
  }, (0, _utils.numberToCurrencyString)(allChildTotal)), /*#__PURE__*/_react.default.createElement(_CollapseInfo.default, {
    label: "Total College Savings Goal",
    total: (0, _utils.numberToCurrencyString)(allChildTotal),
    id: "collegeSavingsTotal",
    contentArray: contentArray1
  }), collapseArray, /*#__PURE__*/_react.default.createElement(_CollegeSavingsRefineModal.default, {
    show: showRefinement,
    handleClose: closeAndResetRefinementModal,
    apiData: apiData,
    snapshot: snapshot,
    fetchDataScienceResults: fetchDataScienceResults
  }), /*#__PURE__*/_react.default.createElement(_DisclosureModal.default, {
    show: showDisclosureModal,
    handleClose: disclosureHandleClose,
    textArray: disclosureArray
  }));
}
var childMap = {
  1: 'First',
  2: 'Second',
  3: 'Third',
  4: 'Fourth',
  5: 'Fifth',
  6: 'Sixth'
};